import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Printer, ArrowLeft } from 'lucide-react';

const DOCS = [
  {
    id: 'operating-agreement',
    title: 'Operating Agreement',
    subtitle: 'ISUPPLYAI, LLC',
    htmlPath: '/downloads/operating-agreement.html',
  },
  {
    id: 'organizational-minutes',
    title: 'Organizational Minutes',
    subtitle: 'ISUPPLYAI, LLC',
    htmlPath: '/downloads/organizational-minutes.html',
  },
];

const DocumentsPage = () => {
  const handlePrint = (doc) => {
    const w = window.open(doc.htmlPath, '_blank');
    if (w) w.onload = () => w.print();
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-testid="docs-back-link">
            <ArrowLeft className="w-4 h-4" /> Back to iSupplyAI
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-center mb-2" data-testid="docs-page-title">LLC Documents</h1>
        <p className="text-center text-gray-400 mb-4">Print single-sided for proper legal formatting</p>
        <div className="grid gap-6 md:grid-cols-2">
          {DOCS.map((doc) => (
            <div key={doc.id} className="rounded-xl border border-white/10 bg-white/5 p-6 flex flex-col gap-4" data-testid={`doc-card-${doc.id}`}>
              <div className="flex items-start gap-3">
                <FileText className="w-8 h-8 text-purple-400 shrink-0 mt-1" />
                <div>
                  <h2 className="text-lg font-semibold">{doc.title}</h2>
                  <p className="text-sm text-purple-300">{doc.subtitle}</p>
                </div>
              </div>
              <button
                onClick={() => handlePrint(doc)}
                className="flex items-center justify-center gap-2 w-full px-4 py-3 rounded-lg bg-purple-600 hover:bg-purple-500 font-medium transition-colors"
                data-testid={`print-btn-${doc.id}`}
              >
                <Printer className="w-5 h-5" /> Open & Print
              </button>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-gray-500 mt-10">Make sure "Print on both sides" is OFF in your printer settings.</p>
      </main>
    </div>
  );
};

export default DocumentsPage;
